import $ from 'jquery';

let selectId = '#workingarea';

$(selectId).on('change', function() {
    if(this.value === 'region'){
        $('.radius-content').hide();
        $('.region-content').show();
    }else{
        $('.region-content').hide();
        $('.radius-content').show();
    }
});
